module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-col', [_c('v-ons-row', {
    staticClass: "color-chart-text"
  }, [_c('v-ons-col', {
    staticClass: "color-chart-min"
  }, [_vm._v("暗い")]), _vm._v(" "), _c('v-ons-col', {
    staticClass: "color-chart-max"
  }, [_vm._v("明るい")])], 1), _vm._v(" "), _c('div', {
    staticClass: "color-chart"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a154914","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/visualization/color_chart/brightness.vue
// module id = 826
// module chunks = 0